import { ControlValueAccessor } from '@angular/forms';

export abstract class BaseControlClass implements ControlValueAccessor {
    private value: unknown;

    public onChange: (value: unknown | undefined) => void = () => {
        return;
    };

    public onTouched: () => void = () => {
        return;
    };

    public writeValue(value: unknown): void {
        this.value = value;
    }

    public registerOnChange(fn: (value: unknown | undefined) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    protected notifyValueChange(value: unknown): void {
        this.value = value;
        this.onChange(value);
        this.onTouched();
    }
}
